/*LIBRARY*/
import { Component } from "react";
import { connect } from "react-redux";

/*COMPONENT*/
import SPINNER from "../common_spinner/SPINNER";

/*REDUX*/
import {
  gen_action,
  set_value_sini_data,
} from "../../App/actions/sini_data_actions";
import { post_ai_chat } from "../../App/actions/post_ai_chat";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

class TEXT_AREA_CHAT extends Component {
  state = {
    title_sini: "",
  };

  on_change_props = (event) => {
    const { max_rows_text_area } = this.props.sini_data_reducer;
    const textarea_line_height = 24;
    const previous_rows = event.target.rows;
    event.target.rows = 1;

    const current_rows = Math.floor(
      event.target.scrollHeight / textarea_line_height
    );

    if (current_rows === previous_rows) {
      event.target.rows = current_rows;
    }

    if (current_rows >= max_rows_text_area) {
      event.target.rows = max_rows_text_area;
      event.target.scrollTop = event.target.scrollHeight;
    }

    const name = event.target.name;
    const value = event.target.value;

    this.props.set_value_sini_data({
      key: name,
      value,
    });

    if (value.trim() === "") {
      this.props.set_value_sini_data({
        key: "rows_text_area",
        value: 1,
      });
    } else {
      // Update rows based on actual content
      this.props.set_value_sini_data({
        key: "rows_text_area",
        value:
          current_rows < max_rows_text_area ? current_rows : max_rows_text_area,
      });
    }
  };

  on_init_sini_data = () => {
    const { prompt_text } = this.props.sini_data_reducer;
    const { sini_v2_list, request_id_active, ai_parent_detail_list } =
      this.props.sini;

    const merge_array = [...sini_v2_list, ...ai_parent_detail_list];
    const sini_object = merge_array.find(
      (item) => item.request_id === request_id_active
    );
    const body = {
      request_id: request_id_active,
      user_message: prompt_text,
      sini_object,
    };
    this.props.post_ai_chat(body);

    this.props.set_value_sini_data({
      key: "prompt_text",
      value: "",
    });
    this.props.set_value_sini_data({
      key: "rows_text_area",
      value: 1,
    });
    this.props.on_scroll_down();
  };

  render() {
    //local storage
    const language = localStorage?.language || this.props.auth.language;

    //local state

    //global props
    const { loading_item_array } = this.props.loading_reducer;
    const { prompt_text, rows_text_area } = this.props.sini_data_reducer;

    //content

    return (
      <main>
        <textarea
          placeholder={
            dict?.["Ask business, land prices, competitors"]?.[language]
          }
          rows={rows_text_area}
          className="margin_bottom"
          value={prompt_text}
          name="prompt_text"
          onChange={this.on_change_props}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.shiftKey) {
              e.preventDefault();
              this.on_init_sini_data();
            }
          }}
          style={{ backgroundColor: "rgba(255, 255, 255, 0.8)" }}
          data-mapid="insertPromp"
        />

        <div className="text_right">
          {loading_item_array.includes("gen_action") ? (
            <button
              className="button_big background_black margin_bottom"
              onClick={this.on_init_sini_data}
            >
              {dict?.["Sending"]?.[language]}{" "}
              <SPINNER
                unik="ai_spinner"
                width={10}
                border={0.25}
                color1="white"
                color2="#28a3f5"
              />
            </button>
          ) : (
            <button
              className="button_big background_black margin_bottom"
              onClick={this.on_init_sini_data}
              data-mapid="clickAsking"
            >
              {dict?.["Send"]?.[language]}
            </button>
          )}
        </div>
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  layer: state.layer,
  project: state.project,
  loading_reducer: state.loading_reducer,
  sini_data_reducer: state.sini_data_reducer,
  sini: state.sini,
});

export default connect(mapStateToProps, {
  set_value_sini_data,
  gen_action,
  post_ai_chat,
})(TEXT_AREA_CHAT);
